module.exports = __webpack_public_path__ + "img/register-student.88cc5cec.svg";